<template>
  <main-sidebar :name="name" :title="$t('filters')">
    <div class="p-4">
      <vs-row vs-w="12" class="mb-2 mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
        <vs-checkbox
            v-model="filters.new_registers"
          >Nuevos</vs-checkbox>
        </vs-col>
      </vs-row>  
      <vs-row vs-w="12" class="mb-2 mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        > 
          <label>{{ $t('client') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="filters.client_id"
            multiple
            :options="clientList"
            class="w-full"
            :reduce="(client) => client.ClientId"
            label="ClientName"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-2 mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('status') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="filters.status_id"
            multiple
            :options="statusList"
            class="w-full"
            :reduce="(status) => status.id"
            label="name"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-2 mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('initial_period') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="filters.start_week"
            :options="periods"
            class="w-full"
            :reduce="(period) => period.PeriodId"
            label="YearWeek"
            @input="clearFinalPeriod"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-2 mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('final_period') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="filters.end_week"
            :options="filteredPeriods"
            class="w-full"
            :reduce="(period) => period.PeriodId"
            label="YearWeek"
          />
        </vs-col>
        <v-select
        :hidden="true"
          />
      </vs-row>
    </div>

    <div class="mx-4" slot="footer">
      <vs-button color="success" type="border" class="mr-6" @click="setFilter">
        {{ $t('apply_filters') }}
      </vs-button>
      <vs-button color="primary" type="border" @click="clear">
        {{ $t('clear_filters') }}
      </vs-button>
    </div>
  </main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import InputDate from '@/components/custom/InputDate'
import vSelect from 'vue-select'
import loading from '@/mixins/Loading'
import client from '@/http/requests/client'
import payroll from '@/http/requests/payroll'
import invoice from '@/http/requests/invoice'

export default {
  components: {
    MainSidebar,
    vSelect,
    InputDate,
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    isLoading() {
      return this.loading.submit || this.loading.client
    },
    filteredPeriods() {
      if (this.filters.start_week != '') {
        return this.periods.filter((item) => {
          return (parseInt(item.PeriodId) >= parseInt(this.filters.start_week))
        });
      }
      return []
    }
  },
  data: () => ({
    clientList: [],
    filters: {
      clients: [],
      status: [],
      start_week: '',
      end_week: '',
      new_registers:true
    },
    name: 'payroll-filter',
    loading: {
      submit: false,
      client: false,
      status: false,
      week: false,
    },
    statusList: [],
    periods: [],
  }),
  methods: {
    clear() {
      const defaultFilter = {
        client_id: [],
        status_id: [],
        start_week: '',
        end_week: '',
      }
      this.filters = Object.assign({}, defaultFilter)
      this.$emit('input', this.filters)
      this.close()
    },
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    init() {
      this.getClientList()
      this.getStatusList()
      this.getPeriods()
      this.filters = Object.assign({}, this.value)
    },
    getClientList() {
      this.loading.client = true
      client
        .list()
        .then((res) => {
          this.clientList = res.data.clients
          this.loading.client = false
        })
        .catch((err) => {
          this.loading.client = false
        })
    },
    getStatusList() {
      this.loading.status = true
      payroll.statusList()
        .then((res) => {
          this.statusList = res.data.data
          this.loading.status = false
        })
        .catch((err) => {
          this.loading.status = false
        })
    },
    getPeriods() {
      this.loading.week = true
       invoice.getPeriodList().then(res => {
          this.periods = res.data.periodList
          this.loading.week = false
        })
        .catch((err) => {
          this.loading.week = false
        })
    },
    setFilter() {
      this.$emit('input', this.filters)
      this.$emit('search')
      this.close()
    },
    clearFinalPeriod(){
      this.filters.end_week=''
    }
  },
  mixins: [loading],
  props: {
    value: {
      type: Object,
      default: () => ({
        client_id: [],
        status_id: [],
        start_week: '',
        end_week: '',
        new_registers:true
      }),
    },
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.init()
      }
    },
    isLoading(val) {
      if (val) {
        this.openLoading(`loading-${this.name}-sidebar`)
      } else {
        this.closeLoading(`loading-${this.name}-sidebar`)
      }
    },
  },
}
</script>

<style>
</style>